<div class="task-activity">
  <div class="task-activity-section">
    <div class="task-activity-header">OPEN TASKS</div>
    <div class="task-activity-empty" *ngIf="!openRows.length">NONE</div>
    <div class="task-card" *ngFor="let row of openRows">
      <div class="task-card-title">{{ row.label }}</div>
      <div class="task-card-body">
        <div class="task-repair-items" *ngIf="hasField(row, 'repairItems')">
          <div class="task-field-label">WHAT NEEDS REPAIR?</div>
          <mat-checkbox
            *ngFor="let option of repairItemOptions"
            [checked]="isRepairItemSelected(row, option)"
            (change)="toggleRepairItem(row, option, $event.checked)"
            [disabled]="locked"
          >
            {{ option }}
          </mat-checkbox>
        </div>

        <mat-form-field
          *ngIf="hasField(row, 'repairItems') && isRepairItemSelected(row, 'Other')"
          appearance="standard"
          class="task-notes"
        >
          <mat-label>OTHER</mat-label>
          <textarea matInput rows="2" [formControl]="row.form.controls.otherText"></textarea>
        </mat-form-field>

        <div class="task-fields">
          <mat-form-field
            *ngIf="hasField(row, 'repairLocation')"
            appearance="standard"
            class="task-field"
          >
            <mat-label>TASK NEEDED</mat-label>
            <mat-select [formControl]="row.form.controls.repairLocation" panelClass="frame-select-panel">
              <mat-option *ngFor="let option of repairLocations" [value]="option">{{ option }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field
            *ngIf="hasField(row, 'eta')"
            appearance="standard"
            class="task-field"
          >
            <mat-label>ETA</mat-label>
            <input matInput [matDatepicker]="openEta" [formControl]="row.form.controls.eta">
            <mat-datepicker-toggle matSuffix [for]="openEta"></mat-datepicker-toggle>
            <mat-datepicker #openEta></mat-datepicker>
          </mat-form-field>

          <mat-form-field
            *ngIf="hasField(row, 'referenceNumber')"
            appearance="standard"
            class="task-field"
          >
            <mat-label>VENDOR REFERENCE #</mat-label>
            <input matInput type="text" autocomplete="off" [formControl]="row.form.controls.referenceNumber">
          </mat-form-field>

          <mat-form-field
            *ngIf="hasField(row, 'followUpDate')"
            appearance="standard"
            class="task-field"
          >
            <mat-label>FOLLOW-UP DATE</mat-label>
            <input matInput [matDatepicker]="openFollow" [formControl]="row.form.controls.followUpDate">
            <mat-datepicker-toggle matSuffix [for]="openFollow"></mat-datepicker-toggle>
            <mat-datepicker #openFollow></mat-datepicker>
          </mat-form-field>

          <mat-form-field
            *ngIf="hasField(row, 'expectedDate')"
            appearance="standard"
            class="task-field"
          >
            <mat-label>EXPECTED DATE</mat-label>
            <input matInput [matDatepicker]="openExpected" [formControl]="row.form.controls.expectedDate">
            <mat-datepicker-toggle matSuffix [for]="openExpected"></mat-datepicker-toggle>
            <mat-datepicker #openExpected></mat-datepicker>
          </mat-form-field>

          <mat-form-field
            *ngIf="hasField(row, 'estimate')"
            appearance="standard"
            class="task-field"
          >
            <mat-label>ESTIMATE</mat-label>
            <input matInput type="text" autocomplete="off" [formControl]="row.form.controls.estimate">
            <span matPrefix>$&nbsp;</span>
          </mat-form-field>

          <mat-checkbox
            *ngIf="hasField(row, 'estimateApprovalRequired')"
            class="task-approval-check"
            [formControl]="row.form.controls.estimateApprovalRequired"
            [disabled]="locked"
          >
            EST APPROVAL REQ.
          </mat-checkbox>

          <mat-form-field
            *ngIf="hasField(row, 'waitingOn')"
            appearance="standard"
            class="task-field"
          >
            <mat-label>WAITING ON</mat-label>
            <mat-select [formControl]="row.form.controls.waitingOn" panelClass="frame-select-panel">
              <mat-option *ngFor="let option of waitingOnOptions" [value]="option">{{ option }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field
            *ngIf="hasField(row, 'whoToCall')"
            appearance="standard"
            class="task-field"
          >
            <mat-label>WHO TO CALL</mat-label>
            <input matInput type="text" autocomplete="off" [formControl]="row.form.controls.whoToCall">
          </mat-form-field>

          <mat-form-field
            *ngIf="hasField(row, 'vendor')"
            appearance="standard"
            class="task-field"
          >
            <mat-label>VENDOR</mat-label>
            <input matInput type="text" autocomplete="off" [formControl]="row.form.controls.vendor">
          </mat-form-field>

          <mat-form-field
            *ngIf="hasField(row, 'labVendor')"
            appearance="standard"
            class="task-field"
          >
            <mat-label>REPAIR VENDOR</mat-label>
            <input matInput type="text" autocomplete="off" [formControl]="row.form.controls.labVendor">
          </mat-form-field>

          <mat-form-field
            *ngIf="hasField(row, 'description')"
            appearance="standard"
            class="task-field task-field-wide"
          >
            <mat-label>DESCRIPTION</mat-label>
            <input matInput type="text" autocomplete="off" [formControl]="row.form.controls.description">
          </mat-form-field>

          <mat-form-field
            *ngIf="hasField(row, 'carrier')"
            appearance="standard"
            class="task-field"
          >
            <mat-label>CARRIER</mat-label>
            <input matInput type="text" autocomplete="off" [formControl]="row.form.controls.carrier">
          </mat-form-field>

          <mat-form-field
            *ngIf="hasField(row, 'trackingNumber')"
            appearance="standard"
            class="task-field"
          >
            <mat-label>TRACKING NUMBER</mat-label>
            <input matInput type="text" autocomplete="off" [formControl]="row.form.controls.trackingNumber">
          </mat-form-field>

          <mat-form-field
            *ngIf="row.actions.length"
            appearance="standard"
            class="task-field"
          >
            <mat-label>ACTIVITY</mat-label>
            <mat-select [formControl]="row.form.controls.activityChoice" panelClass="frame-select-panel">
              <mat-option *ngFor="let option of row.actions" [value]="option">{{ option }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="task-contact" *ngIf="hasField(row, 'contact') && contactLine(row.form.value.waitingOn)">
          {{ contactLine(row.form.value.waitingOn) }}
        </div>

        <mat-form-field
          *ngIf="hasField(row, 'notes')"
          appearance="standard"
          class="task-notes"
        >
          <mat-label>NOTES</mat-label>
          <textarea matInput rows="2" [formControl]="row.form.controls.notes"></textarea>
        </mat-form-field>

        <div class="task-image-row" *ngIf="hasField(row, 'images')">
          <label class="task-image-button">
            ADD INVOICE IMAGE
            <input type="file" accept="image/*" hidden (change)="onTaskImageSelected(row, 'invoice', $event)">
          </label>
          <label class="task-image-button">
            ADD IMAGE
            <input type="file" accept="image/*" multiple hidden (change)="onTaskImageSelected(row, 'condition', $event)">
          </label>
          <div class="task-image-thumbs" *ngIf="(taskImages(row, 'invoice').length + taskImages(row, 'condition').length)">
            <img
              *ngFor="let image of taskImages(row, 'invoice').concat(taskImages(row, 'condition'))"
              [src]="image.dataUrl"
              [alt]="image.name || 'Repair image'"
              (click)="removeTaskImage(row, image)"
            >
          </div>
        </div>

        <div class="task-actions">
          <mat-form-field appearance="standard" class="task-initials">
            <mat-label>INITIALS</mat-label>
            <input matInput type="text" maxlength="4" autocomplete="off" [formControl]="row.form.controls.initials">
          </mat-form-field>
          <button
            mat-stroked-button
            type="button"
            class="task-save"
            [disabled]="locked"
            (click)="saveOpenTask(row)"
          >
            SAVE
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="task-activity-section">
    <div class="task-activity-header">AWAITING</div>
    <div class="task-activity-empty" *ngIf="!awaiting.length">NONE</div>
    <div class="task-card task-card-awaiting" *ngFor="let row of awaiting">
      <div class="task-card-title-row">
        <div class="task-card-title">{{ row.entry.status }}</div>
        <button
          type="button"
          class="task-icon-button"
          [disabled]="locked"
          (click)="toggleAwaitingEdit(row)"
          aria-label="Edit awaiting item"
        >
          <img src="assets/img/task-edit.png" alt="Edit">
        </button>
      </div>
      <div class="task-card-body">
        <div class="task-fields">
          <mat-form-field
            *ngIf="hasField(row, 'vendor')"
            appearance="standard"
            class="task-field"
          >
            <mat-label>VENDOR</mat-label>
            <input matInput type="text" autocomplete="off" [formControl]="row.form.controls.vendor" [readonly]="!row.editing">
          </mat-form-field>
          <mat-form-field
            *ngIf="hasField(row, 'labVendor')"
            appearance="standard"
            class="task-field"
          >
            <mat-label>REPAIR VENDOR</mat-label>
            <input matInput type="text" autocomplete="off" [formControl]="row.form.controls.labVendor" [readonly]="!row.editing">
          </mat-form-field>
          <mat-form-field
            *ngIf="hasField(row, 'eta')"
            appearance="standard"
            class="task-field"
          >
            <mat-label>ETA</mat-label>
            <input matInput [matDatepicker]="awaitEta" [formControl]="row.form.controls.eta" [readonly]="!row.editing">
            <mat-datepicker-toggle matSuffix [for]="awaitEta"></mat-datepicker-toggle>
            <mat-datepicker #awaitEta></mat-datepicker>
          </mat-form-field>
          <mat-form-field
            *ngIf="hasField(row, 'referenceNumber')"
            appearance="standard"
            class="task-field"
          >
            <mat-label>REFERENCE #</mat-label>
            <input matInput type="text" autocomplete="off" [formControl]="row.form.controls.referenceNumber" [readonly]="!row.editing">
          </mat-form-field>
          <mat-form-field
            *ngIf="hasField(row, 'waitingOn')"
            appearance="standard"
            class="task-field"
          >
            <mat-label>WAITING ON</mat-label>
            <mat-select [formControl]="row.form.controls.waitingOn" panelClass="frame-select-panel" [disabled]="!row.editing && !row.form.value.activityChoice">
              <mat-option *ngFor="let option of waitingOnOptions" [value]="option">{{ option }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field
            *ngIf="hasField(row, 'followUpDate')"
            appearance="standard"
            class="task-field"
          >
            <mat-label>FOLLOW-UP DATE</mat-label>
            <input matInput [matDatepicker]="awaitFollow" [formControl]="row.form.controls.followUpDate">
            <mat-datepicker-toggle matSuffix [for]="awaitFollow"></mat-datepicker-toggle>
            <mat-datepicker #awaitFollow></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="standard" class="task-field">
            <mat-label>ACTIVITY</mat-label>
            <mat-select [formControl]="row.form.controls.activityChoice" panelClass="frame-select-panel">
              <mat-option value=""></mat-option>
              <mat-option *ngFor="let option of awaitingChoices(row)" [value]="option">{{ option }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="task-actions">
          <mat-form-field appearance="standard" class="task-initials">
            <mat-label>INITIALS</mat-label>
            <input matInput type="text" maxlength="4" autocomplete="off" [formControl]="row.form.controls.initials">
          </mat-form-field>
          <button
            mat-stroked-button
            type="button"
            class="task-save"
            [disabled]="locked"
            (click)="saveAwaiting(row)"
          >
            SAVE
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="task-activity-section">
    <div class="task-activity-header">COMPLETED</div>
    <div class="task-activity-empty" *ngIf="!completed.length">NONE</div>
    <div class="task-completed-row" *ngFor="let row of completed">
      <div class="task-completed-line">{{ completedLine(row) }}</div>
      <div class="task-completed-notes" *ngIf="row.entry.notes">
        Notes: {{ row.entry.notes }}
      </div>
      <div class="task-completed-actions" *ngIf="canReopen(row)">
        <mat-form-field appearance="standard" class="task-initials">
          <mat-label>INITIALS</mat-label>
          <input matInput type="text" maxlength="4" autocomplete="off" [formControl]="row.form.controls.initials">
        </mat-form-field>
        <button
          type="button"
          class="task-icon-button task-reopen-button"
          [disabled]="locked"
          (click)="reopenCompletedTask(row)"
          aria-label="Reopen completed task"
        >
          <img src="assets/img/task-reopen.png" alt="Reopen">
        </button>
        <span class="task-reopen-label">REOPEN</span>
      </div>
    </div>
  </div>
</div>
